
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import util from '../../util'
import TextButton from '@/components/ui/TextButton.vue'
import SavesCard from '@/components/SavesCard.vue'
import SaveSystem from '@/SaveSystem'
import PatreonButton from '@/components/ui/PatreonButton.vue'
import { Personality } from "@/employee/Personality"
import { allPersonalities } from "@/employee/Personalities"
import HelpMenu from "@/components/screens/HelpMenu.vue"
import PatchNotesScreen from "@/components/screens/PatchNotesScreen.vue"
import CreditsScreen from "@/components/screens/CreditsScreen.vue"

@Options({
  components: {
    TextButton, PatreonButton, HelpMenu, PatchNotesScreen, CreditsScreen
  },
  props: {
    saveSystem: Object
  },
  emits: ['goto-view', 'close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    window() {
      return window
    },
    allPersonalities(): Personality[] {
      return Object.entries(allPersonalities()).map(value => value[1])
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class StartMenu extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
}
